import React from 'react';

import { Modal, ModalBody } from 'reactstrap';

const ModalBase = ({ isOpen, toggle, containerClass='', overlay=true, children }) => {
	const toggleModal = () => toggle && toggle(!isOpen);

	return (
		<Modal
			isOpen={isOpen}
			centered
			fade={false}
			className={containerClass}
			toggle={toggleModal}
			backdrop={overlay}
		>
			<ModalBody>
			{children}
			</ModalBody>
		</Modal>
	);
};

export default ModalBase;
